import { ResourceLoadingState } from "../../common/store/stateHelpers";
import { RegisteredCompanyModel } from "../models/CompanyModels";
import { Reducer } from "react-redux-form";

export enum ActionType {
    RequestRegisteredCompanies = "COMPANIES/REQUEST_REGISTERED",
    ReceivedRegisteredCompanies = "COMPANIES/RECEIVED_REGISTERED",
    AcceptCompany = "COMPANIES/ACCEPT", 
    DeleteCompany = "COMPANIES/DELETE",
    RejectCompany = "COMPANIES/REJECT",
    AdminDeleteUser = "USERS/DELETE",
    CreatePartnerApiKey = "COMPANIES/CREATEPARTNERAPIKEY"
}

interface RequestRegisteredCompaniesAction {
    type: ActionType.RequestRegisteredCompanies
}

interface ReceivedRegisteredCompaniesAction {
    type: ActionType.ReceivedRegisteredCompanies,
    data: RegisteredCompanyModel[]
}

export interface DeleteCompanyAction {
    type: ActionType.DeleteCompany;
    companyId: string;
}

export interface AcceptAction {
    type: ActionType.AcceptCompany,
    companyId: string
}

export interface RejectAction {
    type: ActionType.RejectCompany,
    companyId: string
}

export interface AdminDeleteUserAction {
    type: ActionType.AdminDeleteUser;
    userId: string;
}

export interface CreatePartnerApiKeyAction {
    type: ActionType.CreatePartnerApiKey;
    companyId: string;
}

export const actionCreators = {
    requestRegisteredCompanies: () => <RequestRegisteredCompaniesAction>{ type: ActionType.RequestRegisteredCompanies },
    receivedRegisteredCompanies: (data: RegisteredCompanyModel[]) => <ReceivedRegisteredCompaniesAction>{ type: ActionType.ReceivedRegisteredCompanies, data },
    acceptCompany: (companyId: string) => <AcceptAction>{ type: ActionType.AcceptCompany, companyId },
    deleteCompany: (companyId: string) => <DeleteCompanyAction> { type: ActionType.DeleteCompany, companyId},
    rejectCompany: (companyId: string) => <RejectAction>{ type: ActionType.RejectCompany, companyId },
    adminDeleteUser: (userId: string) => <AdminDeleteUserAction> { type: ActionType.AdminDeleteUser, userId},
    createPartnerApiKey: (companyId: string) => <CreatePartnerApiKeyAction> { type: ActionType.CreatePartnerApiKey, companyId}
}

export type CompaniesState = ResourceLoadingState<RegisteredCompanyModel>;

const initialState: CompaniesState = {
    isLoading: false,
    data: []
}

type CompanyAction = RequestRegisteredCompaniesAction | ReceivedRegisteredCompaniesAction;

export const reducer: Reducer<CompaniesState> = (state: CompaniesState, action: CompanyAction) => {
    switch (action.type) {
        case ActionType.RequestRegisteredCompanies:
            return {
                isLoading: true,
                data: []
            }
        case ActionType.ReceivedRegisteredCompanies:
            return {
                isLoading: false,
                data: action.data
            }        
        default:
            const exhaustiveCheck: never = action;
    }

    return state || initialState;
}


// WEBPACK FOOTER //
// ./src/admin/store/companiesStore.ts